import React from 'react';
import { CheckCircle2, Circle, ShieldCheck, Clock, AlertTriangle } from 'lucide-react';
import ToolPageLayout from '../../components/ToolPageLayout';
import { useLanguage } from '../../contexts/LanguageContext';

const MANDATORY_KEYS = ['prenup_mand_1', 'prenup_mand_2', 'prenup_mand_3', 'prenup_mand_4', 'prenup_mand_5'];
const RECOMMENDED_KEYS = ['prenup_rec_1', 'prenup_rec_2', 'prenup_rec_3'];

const PrenuptialCertificate = () => {
  const { t } = useLanguage();
  return (
    <ToolPageLayout
      title={t('prenup_title')}
      subtitle={t('prenup_subtitle')}
      specialty="generaliste"
    >
      <div className="bg-[#E6F4FB] border border-[#0596DE]/20 rounded-2xl p-4 flex gap-3 mb-8">
        <ShieldCheck className="w-5 h-5 text-[#0596DE] shrink-0 mt-0.5" />
        <p className="text-sm text-[#0F172A]">
          {t('prenup_intro')}
        </p>
      </div>

      <div className="mb-8">
        <h3 className="font-semibold text-[#0F172A] mb-3">{t('prenup_mandatory_heading')}</h3>
        <div className="space-y-2">
          {MANDATORY_KEYS.map((key, i) => (
            <div key={i} className="flex gap-3 items-start bg-white border border-[#E2E8F0] rounded-xl p-3">
              <CheckCircle2 className="w-5 h-5 text-[#10B981] shrink-0 mt-0.5" />
              <p className="text-sm text-[#0F172A]">{t(key)}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-8">
        <h3 className="font-semibold text-[#0F172A] mb-3">{t('prenup_recommended_heading')}</h3>
        <div className="space-y-2">
          {RECOMMENDED_KEYS.map((key, i) => (
            <div key={i} className="flex gap-3 items-start bg-white border border-[#E2E8F0] rounded-xl p-3">
              <Circle className="w-5 h-5 text-[#F59E0B] shrink-0 mt-0.5" />
              <p className="text-sm text-[#0F172A]">{t(key)}</p>
            </div>
          ))}
        </div>
        <p className="text-xs text-[#94A3B8] mt-2">
          {t('prenup_rec_note')}
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 mb-8">
        <div className="bg-[#F0FDF4] border border-[#10B981]/30 rounded-2xl p-5">
          <AlertTriangle className="w-5 h-5 text-[#10B981] mb-2" />
          <p className="font-semibold text-[#065F46] text-sm mb-1">{t('prenup_right_heading')}</p>
          <p className="text-sm text-[#0F172A]">
            {t('prenup_right_text')}
          </p>
        </div>
        <div className="bg-[#FFFBEB] border border-[#F59E0B]/30 rounded-2xl p-5">
          <Clock className="w-5 h-5 text-[#F59E0B] mb-2" />
          <p className="font-semibold text-[#92400E] text-sm mb-1">{t('prenup_validity_heading')}</p>
          <p className="text-sm text-[#0F172A]">
            {t('prenup_validity_text')}
          </p>
        </div>
      </div>

      <p className="mt-6 text-sm text-[#64748B]">
        {t('prenup_disclaimer')}
      </p>
    </ToolPageLayout>
  );
};

export default PrenuptialCertificate;
